import { Controller } from "@hotwired/stimulus"

const COLLAPSED_KEY = "nav_apps_collapsed"

// Collapse only the expanded rail's app group. CSS keeps compact rail and
// phone/dock navigation available regardless of the saved section state.
export default class extends Controller {
    static targets = ["toggle"]

    connect() {
        let collapsed = false
        try { collapsed = window.localStorage.getItem(COLLAPSED_KEY) === "true" } catch { /* unavailable storage */ }
        this._apply(collapsed)
    }

    toggle() {
        const collapsed = !this.element.classList.contains("is-collapsed")
        this._apply(collapsed)
        try { window.localStorage.setItem(COLLAPSED_KEY, String(collapsed)) } catch { /* still works on this page */ }
    }

    _apply(collapsed) {
        this.element.classList.toggle("is-collapsed", collapsed)
        this.toggleTarget.setAttribute("aria-expanded", String(!collapsed))
    }
}
